import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { EnquirySubmittedComponent } from "./enquiry-submitted/enquiry-submitted.component";
import { EnquiryDetailComponent } from "./enquiry-detail/enquiry-detail.component";

const routes: Routes = [
    { path: "enquiry", component: EnquiryDetailComponent },
    { path: "submitted", component: EnquirySubmittedComponent },

    { path: "", redirectTo: "/enquiry", pathMatch: "full" },
    //{ path: "**", component: PageNotFoundComponent }
    { path: "**", redirectTo: "/enquiry" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app-routing.module.ts